// Accounting PromoCard Vuex

import state from './promoCardStates.js'
import * as getters from './promoCardGetters.js'
import * as mutations from './promoCardMutations.js'
import * as actions from './promoCardActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
